// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YBia","tabsBox":"styles_tabsBox__1Ob3l","createButton":"styles_createButton__2IBML"};